(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('LenderTorRuleDeleteController', LenderTorRuleDeleteController);

    LenderTorRuleDeleteController.$inject = ['$uibModalInstance', 'entity', 'LenderTorRule'];

    function LenderTorRuleDeleteController($uibModalInstance, entity, LenderTorRule) {
        var vm = this;

        vm.rule = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            LenderTorRule.delete({ id: id }, function () {
                $uibModalInstance.close(true);
            });
        }
    }
})();
